export default {
  init() {
    // JavaScript to be fired on the home page



    if (sessionStorage.getItem('dontLoad') == null) {

      console.log('new');
      $('#loader').css("display", "block");

      setTimeout(function(){
        $('#loader').addClass('done');
        $('.animated-bg').addClass('ready');
      }, 4750);

      setTimeout(function(){
        $('.line-1').addClass('active');
        $('.line-1').each(function () {
            var characters = $(this).text().split("");
            var $this = $(this);
            $this.empty();
            $.each(characters, function (i, el) {
              if(el.indexOf(' ') > -1) {
                el = '<span class="spacer"></div>';
              }
              $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
            });
        });
      }, 5000);

      setTimeout(function(){
        $('.line-2').addClass('active');
        $('.line-2').each(function () {
            var characters = $(this).text().split("");
            var $this = $(this);
            $this.empty();
            $.each(characters, function (i, el) {
              if(el.indexOf(' ') > -1) {
                el = '<span class="spacer"></div>';
              }
              $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
            });
        });
      }, 5500);
      setTimeout(function(){
        $('.line-3').addClass('active');
        $('.line-3').each(function () {
            var characters = $(this).text().split("");
            var $this = $(this);
            $this.empty();
            $.each(characters, function (i, el) {
              if(el.indexOf(' ') > -1) {
                el = '<span class="spacer"></div>';
              }
              $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
            });
        });
      }, 6000);
  

      sessionStorage.setItem('dontLoad', 'true');
    } else {

      console.log('been');

      $('.animated-bg').addClass('ready');

      $('.line-1').addClass('active');
      $('.line-1').each(function () {
          var characters = $(this).text().split("");
          var $this = $(this);
          $this.empty();
          $.each(characters, function (i, el) {
            if(el.indexOf(' ') > -1) {
              el = '<span class="spacer"></div>';
            }
            $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
          });
      });

      setTimeout(function(){
        $('.line-2').addClass('active');
        $('.line-2').each(function () {
            var characters = $(this).text().split("");
            var $this = $(this);
            $this.empty();
            $.each(characters, function (i, el) {
              if(el.indexOf(' ') > -1) {
                el = '<span class="spacer"></div>';
              }
              $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
            });
        });
      }, 500);
      setTimeout(function(){
        $('.line-3').addClass('active');
        $('.line-3').each(function () {
            var characters = $(this).text().split("");
            var $this = $(this);
            $this.empty();
            $.each(characters, function (i, el) {
              if(el.indexOf(' ') > -1) {
                el = '<span class="spacer"></div>';
              }
              $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
            });
        });
      }, 1000);

    }


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js